import React from 'react'
import Navbar from './Navbar'
import Hero from './Hero'
import Features from './Features'
import Services from './Services'
import AppointmentForm from './AppointmentForm' 
import Testimonials from './Testimonials'
import Footer from './Footer'
import Dashboard from './Dashboard'

const Home = () => {
    const isAuthenticated = false; // Replace with your authentication logic

    const waveStyle1 = {
      animation: 'waveUpDown1 4s ease-in-out infinite alternate'
    };
    
    const waveStyle2 = {
      animation: 'waveUpDown2 7s ease-in-out infinite alternate'
    };
    
    const waveStyle3 = {
      animation: 'waveUpDown3 5s ease-in-out infinite alternate'
    };

    return (
      <div className="overflow-hidden">
        <Navbar />
        {!isAuthenticated ? (
          <>
            <Hero />
            
            {/* Wave transition section */}
            <div className="relative bg-white">
              {/* Wave container */}
              <div className="absolute -top-48 md:-top-44 left-0 right-0 h-48 overflow-hidden w-full">
                {/* First wave - slower animation */}
                <div className="absolute bottom-0 left-0 right-0" style={waveStyle1}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-16 md:h-20">
                    <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C57.44,118.92,150.9,77.83,321.39,56.44Z" fill="white" fillOpacity="0.3"></path>
                  </svg>
                </div>

                {/* Second wave - medium animation */}
                <div className="absolute bottom-0 left-0 right-0" style={waveStyle2}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-14 md:h-18">
                    <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" fill="white" fillOpacity="0.5"></path>
                  </svg>
                </div>
                
                {/* Third wave - main white wave */}
                <div className="absolute bottom-0 left-0 right-0" style={waveStyle3}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-12 md:h-16">
                    <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C57.44,118.92,150.9,77.83,321.39,56.44Z" fill="white"></path>
                  </svg>
                </div>  
              </div>
              
              {/* Add a spacer to push the Features section down */}
              <div className="h-12"></div>
              
              {/* Rest of content */}
              <Features />
              <Services />
              {/* <AppointmentForm /> */}
              {/* <Testimonials /> */}
              <Footer />
            </div>
          </>
        ) : (
          <Dashboard />
        )}
      </div>
    )
}

export default Home;